import { CallRequestForm } from './components/CallRequestForm';
import './App.css';

function App() {
  return (
    <div className="app">
      <header className="app-header">
        <div className="logo-container">
          <img src="/propertly-logo.png" alt="Propertly.io" className="logo" />
        </div>
        <h1>Propertly.io Voice Agent</h1>
        <p className="subtitle">Experience AI-Powered Real Estate Calls</p>
      </header>

      <main className="app-main">
        <div className="content-wrapper">
          <div className="info-section">
            <div className="badge">
              <svg className="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
              </svg>
              <span>Try it now</span>
            </div>
            
            <h2>See how your customers will experience AI calls.</h2>
            
            <p className="description">
              Enter your number. Our AI calls you in 30 seconds, greets you by
              name, and shows you exactly how natural, fast, and on-brand your
              customer conversations can be.
            </p>
            
            <p className="note">
              No sales pitch. Just a live demo of what your team can deploy today.
            </p>
          </div>

          <div className="form-section">
            <CallRequestForm />
          </div>
        </div>
      </main>

      <footer className="app-footer">
        <p>&copy; 2024 Propertly.io - Powered by AI Voice Technology</p>
      </footer>
    </div>
  );
}

export default App;

